import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "BusinessBalance",
};
const methods = [
    "AddItem",
    "UpdateItem",
    "DelItem",
    "DelItemList",
    "GetItemById",
    "FindByConditions",
    "GetItemBySubMerId",
    "FindAll",
    "GetPageContentByConditions"
  ];
  
  const factory = (Fun) => {
    utils.extend(Fun.prototype, info);
    methods.forEach((path) => {
        Fun.prototype[path] = function(data) {
          return this.post(path, data);
        };
    });
  };
  
  const BusinessBalanceApi = ZJApi.defineNewApi("BusinessBalanceApi", factory);
  
  export default BusinessBalanceApi;